import React, { useEffect, useState } from "react";
import { PiXFill } from "react-icons/pi";
import { putApi } from "../../../../services/api/globalApi";
import { errorMessage, successMessage } from "../../../../utils/toastify-message/ToastifyMessage";
import { useSelector } from "react-redux";
import { utilsState } from "../../../../sotre/redux/features/utilsSlice";

const { forwardRef, useRef, useImperativeHandle } = React;

const PaymentStatusModal = forwardRef(({ transactionData, reGetData }, ref) => {
  const [showModal, setShowModal] = useState(false);

  useImperativeHandle(ref, () => ({
    showModal() {
      setShowModal(!showModal);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    afterSubmit() {},
  }));

  const { utils } = useSelector(utilsState);

  const formHandler = async () => {
    const path = `admin/wallets/status/${transactionData?._id}`;
    const body = {
      paymentStatus
    }
    try {
      await putApi({ path, body });
      successMessage("تراکنش شما با موفقیت ویرایش شد");
      setShowModal(false);
      reGetData();
    } catch (error) {
      console.log(error);
      errorMessage(error?.response?.data?.errors[0]?.message);
    }
  };

  const [paymentStatus, setPaymentStatus] = useState(null);

  useEffect(() => {
    if (transactionData?.paymentStatus) {
      setPaymentStatus(transactionData?.paymentStatus);
      console.log(transactionData);
    }
  }, [transactionData]);

  console.log(paymentStatus);

  return (
    <>
      <div
        className={`fixed top-0 right-0 w-full h-full bg-black/40 transition-all z-30  ${
          !showModal && "hidden"
        }`}
      ></div>
      <div
        className={`w-[340px] md:w-[768px] py-4 max-h-[360px] overflow-y-scroll bg-white mt-4 shadow-md z-40 rounded-3xl p-4 transition-all fixed top-0 right-[50%] mr-[-170px] md:mr-[-384px] opacity-0 invisible ${
          showModal && "!mt-20 !opacity-100 !visible"
        }`}
      >
        <div className="w-full px-6 flex items-center justify-between py-4 border-b-2">
          <h4>ویرایش تراکنش {transactionData?.trackingCode}</h4>
          <PiXFill
            onClick={() => setShowModal(false)}
            size={30}
            className="text-red-400 transition-all hover:text-red-600 cursor-pointer"
          />
        </div>
        <div className="bg-white/50 backdrop-blur-sm rounded-2xl p-6 py-3">
          <div>
            <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
              تغیر وضعیت تراکنش
            </label>
            <select
              value={paymentStatus}
              onChange={(e) => setPaymentStatus(e.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            >
              {utils
                ? utils?.PAYMENT_STATUS_VALUES.map((item) => {
                    return <option value={item.value}>{item.name}</option>;
                  })
                : null}
            </select>
          </div>

          <div className="mt-4 flex justify-end w-full">
            <button
              type="button"
              onClick={formHandler}
              className="text-white text-lg bg-indigo-700 hover:bg-indigo-800 focus:outline-none focus:ring-4 focus:ring-indigo-300 font-medium rounded-full px-8 py-2.5 text-center me-2 mb-2 dark:bg-indigo-600 dark:hover:bg-indigo-700 dark:focus:ring-indigo-800"
            >
              ویرایش
            </button>
          </div>
        </div>
      </div>
    </>
  );
});
export default PaymentStatusModal;
